import _ from 'underscore';

export function parseJsonFormatImportOptions({
  options,
  isPageFeedEnabled,
  storeList = [],
  isDeviceTargetOptimizationEnabled = false,
  isAdScheduleUseSearcherTimezoneEnabled = false,
  isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled = false,
  isGoogleImageExtensionImportOptionEnabled = false,
  isAudienceTargetForFBImportOptionEnabled = false,
  isGoogleLogoExtensionImportOptionEnabled = false,
  isGoogleUpdateAdUrlsImportOptionEnabled = false,
  isGoogleUpdateSitelinkUrlsImportOptionEnabled = false,
  isGoogleAccountNegativeKeywordsImportOptionEnabled = false,
  isGoogleAdCustomizerAttributesImportOptionEnabled = false,
  isGoogleConversionGoalsImportOptionEnabled = false,
  isBrandSuitabilityImportOptionEnabled = false,
}) {
  let mappedOptions = {
    // ImportNewItems
    ImportNewEntities: options.ImportNewEntities,
    ImportNewOption_ImportNewCampaignsAndMarkAsPaused: options.PauseNewCampaigns,
    ImportNewOption_ImportNewCampaignsAndChildEntities: options.ImportNewCampaignsAndChildEntities,
    ImportNewOption_ImportNewAdGroupsAndChildEntitiesForExistingCampaigns:
      options.ImportNewAdGroupsAndChildEntitiesForExistingCampaigns,
    ImportNewOption_ImportNewAdsForExistingAdGroups: options.ImportNewAdsForExistingAdGroups,
    ImportNewOption_ImportNewKeywordsForExistingAdGroups:
      options.ImportNewKeywordsForExistingAdGroups,
    ImportNewOption_ImportNewNegativeKeywordsForExistingParents:
      options.ImportNewNegativeKeywordsForExistingParents,
    ImportNewOption_ImportNewNegativeKeywordList: options.ImportNewNegativeKeywordList,
    ImportNewOption_ImportNewLocationTargets: options.ImportNewLocationTargets,
    ImportNewOption_ImportNewAppAdExtensions: options.ImportNewAppAdExtensions,
    // ExistingItems
    UpdateEntityPreferences: options.ImportUpdatedEntities,
    ImportUpdateEntityPreference_UpdateCampaignBudget: options.UpdateCampaignBudgets,
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids: options.UpdateBids,
    ImportUpdateEntityPreference_UpdateExistingNegativeKeywordList:
      options.UpdateNegativeKeywordLists,
    ImportUpdateEntityPreference_UpdateNegativeSites: options.UpdateNegativeSites,
    ImportUpdateEntityPreference_UpdateKeywordDestinationUrl: options.UpdateKeywordUrls,
    ImportUpdateEntityPreference_UpdateTrackingTemplateAndCustomParams:
      options.UpdateTrackingTemplatesAndCustomParameters,
    ImportUpdateEntityPreference_UpdateLocationTargets: options.UpdateLocationTargets,
    ImportUpdateEntityPreference_UpdateAdExtensions: options.UpdateAdExtensions,
    ImportUpdateEntityPreference_UpdateStatusForExistingCampaigns: options.UpdateStatusForCampaigns,
    ImportUpdateEntityPreference_UpdateStatusForExistingAdGroups: options.UpdateStatusForAdGroups,
    ImportUpdateEntityPreference_UpdateStatusForExistingAds: options.UpdateStatusForAds,
    ImportUpdateEntityPreference_UpdateStatusForExistingKeywords: options.UpdateStatusForKeywords,
    ImportUpdateEntityPreference_UpdateLanguageForExistingAdGroups:
      options.UpdateLanguageForAdGroup,
    // DeletedItems
    ImportDeletedEntities: options.ImportDeletedEntities,
    // BidsAndBudgets
    DefaultBidsBelowMinToAdCenterMinBid: options.SetLowerBidsToAdCenterMinBids,
    DefaultCampaignBudgetBelowMinToAdCenterMinBudget:
      options.SetLowerCampaignBudgetsToAdCenterMinCampaignBudgets,
    // OtherItems
    ImportAppendDestUrlPreference_UseAppendString:
      !!options.PrefixAndSuffixForUrls && options.PrefixAndSuffixForUrls.EnablePrefixAndSuffix,
    ImportAppendDestUrlPreference_AppendStringForDestinationUrl:
      options.PrefixAndSuffixForUrls ?
        options.PrefixAndSuffixForUrls.SuffixString : '',
    ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString:
      !!options.SearchAndReplaceForUrls && options.SearchAndReplaceForUrls.EnableSearchAndReplace,
    ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl:
      options.SearchAndReplaceForUrls ?
        options.SearchAndReplaceForUrls.SearchString : '',
    ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl:
      options.SearchAndReplaceForUrls ?
        options.SearchAndReplaceForUrls.ReplaceString : '',

    AppendPreferencesForTrackingTemplate_UseAppendString:
      !!options.PrefixAndSuffixForTrackingTemplates &&
      options.PrefixAndSuffixForTrackingTemplates.EnablePrefixAndSuffix,
    AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate:
      options.PrefixAndSuffixForTrackingTemplates ?
        options.PrefixAndSuffixForTrackingTemplates.SuffixString : '',
    SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString:
      !!options.SearchAndReplaceForTrackingTemplates &&
      options.SearchAndReplaceForTrackingTemplates.EnableSearchAndReplace,
    SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate:
      options.SearchAndReplaceForTrackingTemplates ?
        options.SearchAndReplaceForTrackingTemplates.SearchString : '',
    SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate:
      options.SearchAndReplaceForTrackingTemplates ?
        options.SearchAndReplaceForTrackingTemplates.ReplaceString : '',
    AppendPreferencesForCustomParameter_UseAppendString:
      !!options.PrefixAndSuffixForTrackingTemplates &&
      options.PrefixAndSuffixForTrackingTemplates.EnablePrefixAndSuffix,
    AppendPreferencesForCustomParameter_AppendStringForCustomParameter:
      options.PrefixAndSuffixForTrackingTemplates ?
        options.PrefixAndSuffixForTrackingTemplates.SuffixString : '',
    AppendPreferencesForFinalURLSuffix_UseAppendString:
      !!options.PrefixAndSuffixForTrackingTemplates &&
        options.PrefixAndSuffixForTrackingTemplates.EnablePrefixAndSuffix,
    AppendPreferencesForFinalURLSuffix_AppendStringForFinalURLSuffix:
        options.PrefixAndSuffixForTrackingTemplates ?
          options.PrefixAndSuffixForTrackingTemplates.SuffixString : '',

    // behavior for option is opposite of the enum name (if checked, don't pass back this value)
    ImportUpdateEntityPreference_UpdateNameForExistingCampaigns: !options.UpdateCampaignNames,
    ImportNewOption_ImportNewActiveEntitiesOnly: !options.ImportActiveOnlyNewCampaigns,
    StoreIdForImportedProductAdExtensionsFlag: !!options.AssociatedBingMerchantCenterStoreId
      || (_.size(storeList) === 1),
    StoreIdForImportedProductAdExtensions: options.AssociatedBingMerchantCenterStoreId,
    AvailableStoreValues: _.map(_.pluck(storeList, 'Value'), id => parseInt(id, 10)),
    AvailableStoreValueMessages: _.pluck(storeList, 'Text'),
    // import options v2 options:
    ImportNewOption_ImportNewDayTimeTargets: options.ImportNewDayTimeTargets,
    ImportNewOption_ImportNewDeviceTargets: options.ImportNewDeviceTargets,
    ImportNewOption_ImportNewDemographicTargets: options.ImportNewDemographicTargets,
    ImportNewOption_ImportNewCallAdExtensions: options.ImportNewCallAdExtensions,
    ImportNewOption_ImportNewCalloutAdExtensions: options.ImportNewCalloutAdExtensions,
    ImportNewOption_ImportNewLocationAdExtensions: options.ImportNewLocationAdExtensions,
    ImportNewOption_ImportNewPriceAdExtensions: options.ImportNewPriceAdExtensions,
    ImportNewOption_ImportNewPromotionAdExtensions: options.ImportNewPromotionAdExtensions,
    ImportNewOption_ImportNewReviewAdExtensions: options.ImportNewReviewAdExtensions,
    ImportNewOption_ImportNewSitelinkAdExtensions: options.ImportNewSitelinkAdExtensions,
    ImportNewOption_ImportNewStructuredSnippetAdExtensions:
      options.ImportNewStructuredSnippetAdExtensions,
    ImportUpdateEntityPreference_UpdateDayTimeTargets: options.UpdateDayTimeTargets,
    ImportUpdateEntityPreference_UpdateDeviceTargets: options.UpdateDeviceTargets,
    ImportUpdateEntityPreference_UpdateDemographicTargets: options.UpdateDemographicTargets,
    ImportUpdateEntityPreference_UpdateAppAdExtensions: options.UpdateAppAdExtensions,
    ImportUpdateEntityPreference_UpdateCallAdExtensions: options.UpdateCallAdExtensions,
    ImportUpdateEntityPreference_UpdateCalloutAdExtensions: options.UpdateCalloutAdExtensions,
    ImportUpdateEntityPreference_UpdateLocationAdExtensions: options.UpdateLocationAdExtensions,
    ImportUpdateEntityPreference_UpdatePriceAdExtensions: options.UpdatePriceAdExtensions,
    ImportUpdateEntityPreference_UpdatePromotionAdExtensions: options.UpdatePromotionAdExtensions,
    ImportUpdateEntityPreference_UpdateReviewAdExtensions: options.UpdateReviewAdExtensions,
    ImportUpdateEntityPreference_UpdateSitelinkAdExtensions: options.UpdateSitelinkAdExtensions,
    ImportUpdateEntityPreference_UpdateStructuredSnippetAdExtensions:
      options.UpdateStructuredSnippetAdExtensions,

    ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix:
      !!options.PrefixAndSuffixForCampaignNames &&
      options.PrefixAndSuffixForCampaignNames.EnablePrefixAndSuffix,
    ImportPrefixAndSuffixForStringProperty_SuffixString:
      options.PrefixAndSuffixForCampaignNames ?
        options.PrefixAndSuffixForCampaignNames.SuffixString : '',
    ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace:
      !!options.SearchAndReplaceForCampaignNames &&
      options.SearchAndReplaceForCampaignNames.EnableSearchAndReplace,
    ImportSearchAndReplaceForStringProperty_SearchString:
      options.SearchAndReplaceForCampaignNames ?
        options.SearchAndReplaceForCampaignNames.SearchString : '',
    ImportSearchAndReplaceForStringProperty_ReplaceString:
      options.SearchAndReplaceForCampaignNames ?
        options.SearchAndReplaceForCampaignNames.ReplaceString : '',

    PauseAdGroupIfNoLocationSupported: options.PauseAdGroupIfNoLocationSupported,
    EnableAutoCurrencyConversion: options.EnableAutoCurrencyConversion,
  };

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewKeywordUrls: options.ImportNewKeywordUrls,
    ImportNewOption_ImportNewTrackingTemplateAndCustomParams:
      options.ImportNewTrackingTemplateAndCustomParams,
    ImportNewOption_ImportNewNegativeSites: options.ImportNewNegativeSites,
    ImportUpdateEntityPreference_UpdateAdGroupNetworkSetting: options.UpdateAdGroupNetworkSetting,
    AdjustmentForBids_EnableAdjustment:
      (options.AdjustmentForBids && options.AdjustmentForBids.EnableAdjustment) || false,
    AdjustmentForBids_AdjustmentValue:
      (options.AdjustmentForBids && options.AdjustmentForBids.AdjustmentValue) || 0,
    AdjustmentForCampaignBudgets_EnableAdjustment:
      (options.AdjustmentForCampaignBudgets
        && options.AdjustmentForCampaignBudgets.EnableAdjustment) || false,
    AdjustmentForCampaignBudgets_AdjustmentValue:
      (options.AdjustmentForCampaignBudgets
          && options.AdjustmentForCampaignBudgets.AdjustmentValue) || 0,
    PauseParentIfNoLocationSupported: options.PauseParentIfNoLocationSupported,
    EnableParentLocationMapping: options.EnableParentLocationMapping === false,
  });

  // ImportAccountUrlOptions should be checked when
  // AdWordsAccountTrackingTemplate is empty (or) contains value
  // since import as a service will treat request with empty string as checked.
  // ImportAccountUrlOptions should not be checked when
  // AdWordsAccountTrackingTemplate is null (or) undefined.
  // for previousImportOptions, the value of ImportAccountUrlOptions is based on users
  // saved preference from last import.

  const AccountLevelTrackingTemplateCheckboxEnabled = !(
    _.isNull(options.UserPreferenceTrackingTemplate)
    || _.isUndefined(options.UserPreferenceTrackingTemplate));

  mappedOptions = _.extend(mappedOptions, {
    TrackingTemplateValue: options.AdWordsAccountTrackingTemplate,
    // if importaccountUrlOptions is undefined look at the tracking template value.
    // if not undefined look at the value of ImportAccountUrlOptions.
    ImportAccountUrlOptions: AccountLevelTrackingTemplateCheckboxEnabled,
  });

  mappedOptions = _.extend(mappedOptions, {
    FinalUrlSuffixValue: options.AdWordsAccountFinalUrlSuffix,
    ImportAccountUrlOptions: AccountLevelTrackingTemplateCheckboxEnabled,
  });

  mappedOptions = _.extend(mappedOptions, {
    RaiseLowBidsToMinServingBidsForBsc: options.RaiseLowBidsToMinServingBidsForBsc,
  });

  if (isDeviceTargetOptimizationEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AutoDeviceBidOptimization: options.AutoDeviceBidOptimization,
    });
  }

  if (isAdScheduleUseSearcherTimezoneEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AdScheduleUseSearcherTimezone: options.AdScheduleUseSearcherTimezone,
    });
  }

  if (isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      PauseAIMAdGroupIfAllAudienceCriterionNotImported:
        !!options.PauseAIMAdGroupIfAllAudienceCriterionNotImported,
    });
  }

  if (isGoogleImageExtensionImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewImageAdExtensions: options.ImportNewImageAdExtensions,
      ImportUpdateEntityPreference_UpdateImageAdExtensions: options.UpdateImageAdExtensions,
    });
  }

  if (isGoogleLogoExtensionImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewLogoAdExtensions: options.ImportNewLogoAdExtensions,
      ImportUpdateEntityPreference_UpdateLogoAdExtensions: options.UpdateLogoAdExtensions,
    });
  }

  if (isGoogleUpdateAdUrlsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateAdUrls: options.UpdateAdUrls,
    });
  }

  if (isGoogleUpdateSitelinkUrlsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateSitelinkUrls: options.UpdateSitelinkUrls,
    });
  }

  if (isGoogleAccountNegativeKeywordsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewAccountNegativeKeywords: options.ImportNewAccountNegativeKeywords,
    });
  }

  if (isGoogleAdCustomizerAttributesImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportUpdateEntityPreference_UpdateAdCustomizerAttributes: options.UpdateAdCustomizerAttributes,
    });
  }

  if (isGoogleConversionGoalsImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewConversionGoals: options.ImportNewConversionGoals,
      ImportUpdateEntityPreference_UpdateConversionGoals: options.UpdateConversionGoals,
    });
  }

  if (isBrandSuitabilityImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewBrandSuitability: options.ImportNewBrandSuitability,
      ImportUpdateEntityPreference_UpdateBrandSuitability: options.UpdateBrandSuitability,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportSearchAndDsaMixedCampaignAsSearchCampaign:
      options.ImportSearchAndDsaMixedCampaignAsSearchCampaign,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAudienceTargets: options.ImportNewAudienceTargets,
    ImportUpdateEntityPreference_UpdateAudienceTargets: options.UpdateAudienceTargets,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportUET: options.ImportNewAudienceTargets && !!options.AssociatedUETTagId,
    AssociatedUETTagId: options.AssociatedUETTagId || '',
  });

  if (isAudienceTargetForFBImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      NoAudienceTargetForFBImportOption:
        !options.ImportNewAudienceTargets && !options.UpdateAudienceTargets,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    RenameCampaignNameWithSuffix: !!options.RenameCampaignNameWithSuffix,
  });

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForCustomParameters_EnableSearchAndReplace:
        !!options.SearchAndReplaceForCustomParameters &&
          options.SearchAndReplaceForCustomParameters.EnableSearchAndReplace,
    SearchAndReplaceForCustomParameters_SearchString:
        options.SearchAndReplaceForCustomParameters ?
          options.SearchAndReplaceForCustomParameters.SearchString : '',
    SearchAndReplaceForCustomParameters_ReplaceString:
        options.SearchAndReplaceForCustomParameters ?
          options.SearchAndReplaceForCustomParameters.ReplaceString : '',
  });

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace:
        !!options.SearchAndReplaceForFinalURLSuffix &&
          options.SearchAndReplaceForFinalURLSuffix.EnableSearchAndReplace,
    SearchAndReplaceForFinalURLSuffix_SearchString:
        options.SearchAndReplaceForFinalURLSuffix ?
          options.SearchAndReplaceForFinalURLSuffix.SearchString : '',
    SearchAndReplaceForFinalURLSuffix_ReplaceString:
        options.SearchAndReplaceForFinalURLSuffix ?
          options.SearchAndReplaceForFinalURLSuffix.ReplaceString : '',
  });

  if (isPageFeedEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewPageFeeds: options.ImportNewPageFeeds,
      ImportUpdateEntityPreference_UpdatePageFeeds: options.UpdatePageFeeds,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAdCustomizerFeeds: options.ImportNewAdCustomizerFeeds,
    ImportUpdateEntityPreference_UpdateAdCustomizerFeeds: options.UpdateAdCustomizerFeeds,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportAllAdUnderAnAdGroup: options.ImportAllAdUnderAnAdGroup,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewLabelsAndAssociations:
      (options.ImportNewLabelsAndAssociations != null)
        ? options.ImportNewLabelsAndAssociations
        : options.ImportNewEntities,
    UpdateLabelsAndAssociations:
      (options.UpdateLabelsAndAssociations != null)
        ? options.UpdateLabelsAndAssociations
        : options.ImportUpdatedEntities,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewCustomFiltersForShoppingCampaigns:
      (options.ImportNewCustomFiltersForShoppingCampaigns != null)
        ? options.ImportNewCustomFiltersForShoppingCampaigns
        : options.ImportNewEntities,
    UpdateCustomFiltersForShoppingCampaigns:
      (options.UpdateCustomFiltersForShoppingCampaigns != null)
        ? options.UpdateCustomFiltersForShoppingCampaigns
        : options.ImportUpdatedEntities,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies:
    !!options.UpdateBiddingStrategies,
  });

  return mappedOptions;
}
